import { buildComponent } from '#components'

const LargeHeader = buildComponent({
  name: 'large-header',
  onConnected: (component) => {
    const html = component.innerHTML
    const transformedHtml = html.replace('[em]', '<em>').replace('[/em]', '</em>')

    component.innerHTML = transformedHtml
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'large-header': typeof LargeHeader
  }
}
